// Hooks
import { useAppSelector } from "app/hooks";

// Store
import { getProjectCompanyData } from "store/slice/Project/projectData/ProjectSlice";

// Mui Components
import { Grid } from "@mui/material";

// Components
import { CompanySummaryHeader, CompanySummaryBody } from "components/CompanySummary";

const CompanySummary = ({ searchAIAutocomplete }: { searchAIAutocomplete?: JSX.Element | boolean }) => {
    const { data: company } = useAppSelector(getProjectCompanyData);

    return (
        <Grid container>
            <Grid item xs={searchAIAutocomplete ? 4 : 12}>
                <CompanySummaryHeader showAvatar title={company?.name ?? ""} />
                <CompanySummaryBody companyData={company} />
            </Grid>
            {searchAIAutocomplete && (
                <Grid item xs={4}>
                    {searchAIAutocomplete}
                </Grid>
            )}
        </Grid>
    );
};

export default CompanySummary;
